import { render, staticRenderFns } from "./ContentsUpload.vue?vue&type=template&id=0b884c26&scoped=true"
import script from "./ContentsUpload.vue?vue&type=script&lang=js"
export * from "./ContentsUpload.vue?vue&type=script&lang=js"
import style0 from "./ContentsUpload.vue?vue&type=style&index=0&id=0b884c26&prod&scoped=true&lang=css"
import style1 from "./ContentsUpload.vue?vue&type=style&index=1&id=0b884c26&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b884c26",
  null
  
)

export default component.exports